import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for grantee registration
export const registerGrantee = createAsyncThunk('granteeRegistration/registerGrantee', async (userData) => {
  const response = await fetch('/api/grantees', {
    method: 'POST',
    body: userData,
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error);
  }
  return data;
});

const granteeRegistrationSlice = createSlice({
  name: 'granteeRegistration',
  initialState: { status: 'idle', error: null },
  reducers: {
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerGrantee.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(registerGrantee.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.granteeRegistration = action.payload;
      })
      .addCase(registerGrantee.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { resetError } = granteeRegistrationSlice.actions;
export default granteeRegistrationSlice.reducer;